import { connect } from 'react-redux';
import Languages from 'profile/components/languages';

export function mapStateToProps({ profile: { view, languages } }) {
  if (!view.data || !languages.data) {
    return {};
  }

  return {
    ...view,
    ...view.data,
    abbreviations: languages.data.abbreviations,
  };
}

export default connect(mapStateToProps)(Languages);



// WEBPACK FOOTER //
// ./profile/containers/languages.js